/**
 * useVocab — devolve o vocabulário do tenant atual.
 * Uso: const v = useVocab(); v.events // "Eventos" ou "Cerimônias" etc
 */
import { useTenant } from '@/hooks/useTenant'
import { DEFAULT_VOCAB, getTemplate, type VocabMap } from '@/constants/professionTemplates'

export function useVocab(): VocabMap {
  const { tenant } = useTenant()
  if (!tenant) return DEFAULT_VOCAB
  // 1) custom do tenant (se sobrescreveu)
  const tenantData = tenant as unknown as { vocab?: Partial<VocabMap>; profession?: string }
  if (tenantData.vocab) {
    return { ...DEFAULT_VOCAB, ...tenantData.vocab }
  }
  // 2) template da profissão escolhida
  if (tenantData.profession) {
    return getTemplate(tenantData.profession).vocab
  }
  // 3) fallback padrão
  return DEFAULT_VOCAB
}

/**
 * useModulesVisible — devolve a lista de módulos visíveis pro tenant.
 * Combina: features do plano + escolha do template + override do tenant.
 */
export function useModulesVisible(): string[] {
  const { tenant } = useTenant()
  if (!tenant) return []
  const t = tenant as unknown as { modules_visible?: string[]; profession?: string }
  if (Array.isArray(t.modules_visible) && t.modules_visible.length > 0) {
    return t.modules_visible
  }
  if (t.profession) {
    return getTemplate(t.profession).modules
  }
  // Fallback: todos os módulos do plano
  return tenant.subscription.features
}

/**
 * usePrimaryColor — cor principal do tenant (white-label).
 */
export function usePrimaryColor(): string {
  const { tenant } = useTenant()
  const t = tenant as unknown as { primary_color?: string; profession?: string }
  if (t?.primary_color) return t.primary_color
  if (t?.profession) return getTemplate(t.profession).default_color
  return '#D4A857'
}
